/**
 * Validation SIRET / SIREN côté client ET serveur : on refuse une saisie
 * invalide avant tout appel réseau, plutôt que de brûler un appel fournisseur.
 */
/** Somme de Luhn — un SIRET valide a une somme de Luhn multiple de 10. */
function luhnSum(digits) {
    let sum = 0;
    for (let i = 0; i < digits.length; i += 1) {
        // On double un chiffre sur deux en partant de la droite.
        const shouldDouble = (digits.length - i) % 2 === 0;
        let digit = Number(digits[i]);
        if (shouldDouble) {
            digit *= 2;
            if (digit > 9)
                digit -= 9;
        }
        sum += digit;
    }
    return sum;
}
export function isValidSiret(siret) {
    const normalized = normalizeSiret(siret);
    if (!/^\d{14}$/.test(normalized))
        return false;
    // Une suite de zéros satisfait Luhn mais n'est attribuée à personne.
    if (/^0+$/.test(normalized))
        return false;
    // La Poste (SIREN 356000000) est la seule exception documentée à la règle de Luhn.
    if (normalized.startsWith('356000000')) {
        const sum = [...normalized].reduce((acc, char) => acc + Number(char), 0);
        return sum % 5 === 0;
    }
    return luhnSum(normalized) % 10 === 0;
}
export function isValidSiren(siren) {
    const normalized = normalizeSiret(siren);
    if (!/^\d{9}$/.test(normalized))
        return false;
    if (/^0+$/.test(normalized))
        return false;
    return luhnSum(normalized) % 10 === 0;
}
/** Retire espaces et points de séparation d'une saisie utilisateur. */
export function normalizeSiret(input) {
    return input.replace(/[\s.\-]/g, '');
}
export function sirenFromSiret(siret) {
    return normalizeSiret(siret).slice(0, 9);
}
/**
 * Numéro de TVA intracommunautaire français : FR + clé (2 chiffres) + SIREN.
 * Clé = (12 + 3 × (SIREN mod 97)) mod 97.
 */
export function vatNumberFromSiren(siren) {
    if (!isValidSiren(siren))
        return null;
    const key = (12 + 3 * (Number(siren) % 97)) % 97;
    return `FR${String(key).padStart(2, '0')}${siren}`;
}
//# sourceMappingURL=siret.js.map